module.exports = __webpack_public_path__ + "img/main_bottom_bottom.ad01ec18.png";